import React from "react";
import { CheckIcon, GiftIcon, InfoIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="bg-mint-50 px-4 py-14 sm:py-20" data-id="element-122" data-mp="1cko90krqrkcu">
      <div className="mx-auto max-w-4xl" data-id="element-123" data-mp="1cj3egv5fg1ez">
        <p className="mx-auto flex w-fit items-center gap-2 rounded-full bg-plum-700 px-4 py-1.5 text-sm font-extrabold text-white" data-id="element-124" data-mp="18k4bhg39aeq6">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="258k0nb2gem2r" />5 FREE BONUSES
        </p>
        <h2 className="mt-4 text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-126" data-mp="20btp911lgeno">
          Your Purchase Also Includes 5 Practical Professional Bonuses
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-slate-700" data-id="element-127" data-mp="1r9am0ftwc00w">
          Tools designed to make your documentation and planning workflow more efficient — reusable forms for common
          clinical organization tasks.
        </p>

        <div className="mt-10 space-y-8" data-id="element-128" data-mp="1etnau71y39m9">
          {bonuses.map(b => <article key={b.number} className="-mx-4 overflow-hidden bg-white shadow-sm sm:mx-0 sm:rounded-3xl sm:ring-1 sm:ring-mint-100" data-id="element-129" data-mp="1erkbgwewk44v">
              <div className="relative" data-id="element-130" data-mp="15ti5s3k84nb9">
                <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-131" data-mp="15sgv4074e2u2" />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-sun px-3 py-1 text-xs font-extrabold text-plum-950" data-id="element-132" data-mp="1au63t96ve4ez">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-133" data-mp="10u5glc5vr45i" />
                  BONUS {b.number} · FREE
                </span>
              </div>
              <div className="p-5 sm:p-6" data-id="element-134" data-mp="n0ny7uoxjxh2">
                <h3 className="font-display text-xl font-extrabold leading-snug text-plum-950 sm:text-2xl" data-id="element-135" data-mp="r3axggnxkkoa">{b.title}</h3>
                <p className="mt-1 font-semibold text-mint-700" data-id="element-136" data-mp="d5mcz9xrzfjr">{b.tagline}</p>
                <p className="mt-3 text-base leading-relaxed text-slate-700" data-id="element-137" data-mp="i3nv9sndnau6">{b.text}</p>
                <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-138" data-mp="2jt3c5ujtfxub">
                  {b.items.map(it => <li key={it} className="flex items-start gap-2 text-[15px] font-medium text-slate-800" data-id="element-139" data-mp="2f1lb76hslx9c">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-600" aria-hidden="true" data-id="element-140" data-mp="2b1b7y1ldxky6" />
                      {it}
                    </li>)}
                </ul>
                <p className="mt-4 rounded-xl bg-plum-50 px-4 py-3 text-[15px] leading-relaxed text-plum-900" data-id="element-141" data-mp="32qeclih6oxbc">
                  <strong data-id="element-142" data-mp="2yr5k0gxvr5hd">Why it matters:</strong> {b.why}
                </p>
                {b.note && <p className="mt-3 flex items-start gap-2 text-xs leading-relaxed text-slate-500" data-id="element-143" data-mp="2tp6h1861yaky">
                    <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-144" data-mp="2or50ov00gpd6" />
                    {b.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-145" data-mp="1dekjh5fveu55">
          <CtaButton label="Claim My 5 Free Bonuses" sub="Included today with your $27 purchase" data-id="element-146" data-mp="1392vafcrf4nb" />
        </div>
      </div>
    </section>;
}